import { isProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { BenefitCinemaItem, TileListItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

export const KUVO_INTERVAL = 6;
export const KUVO_MINIMUM_TILES = 8;
/*                                                                               */
const SDA_BTF_POSITION = 12;

function createBenefitCinemaItem(): BenefitCinemaItem {
    return { type: 'BenefitCinema' };
}

function isKuvoSlotConsumingItem(item: TileListItem): boolean {
    return isProductItem(item);
}

function kuvoPositions(slotCount: number, sdaHoardingEnabled: boolean): number[] {
    const positions: number[] = [];
    for (let pos = KUVO_INTERVAL; pos < slotCount; pos += KUVO_INTERVAL) {
        if (sdaHoardingEnabled && pos === SDA_BTF_POSITION) continue;
        positions.push(pos);
    }
    return positions;
}

function findInsertIndexAfterNthSlotConsumer(items: TileListItem[], n: number): number {
    let slotCount = 0;
    const nthSlotIndex = items.findIndex((item) => {
        if (isKuvoSlotConsumingItem(item)) slotCount++;
        return slotCount === n;
    });

    return nthSlotIndex >= 0 ? nthSlotIndex + 1 : items.length;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function insertBenefitCinemaSlots(tileListItems: TileListItem[], onex?: OnEx): TileListItem[] {
    if (onex?.isToggleActive('EMERGENCY_DISABLE_BENEFIT_CINEMA')) {
        return tileListItems;
    }

    const slotConsumingItemCount = tileListItems.filter(isKuvoSlotConsumingItem).length;
    if (slotConsumingItemCount < KUVO_MINIMUM_TILES) {
        return tileListItems;
    }

    const sdaHoardingEnabled = !onex?.isToggleActive('EMERGENCY_DISABLE_SDA_HOARDING');
    const positions = kuvoPositions(slotConsumingItemCount, sdaHoardingEnabled);

    /**
 *
 *
 */
    let result = [...tileListItems];
    for (const pos of [...positions].reverse()) {
        const insertIndex = findInsertIndexAfterNthSlotConsumer(result, pos);
        if (insertIndex <= result.length) {
            result = [...result.slice(0, insertIndex), createBenefitCinemaItem(), ...result.slice(insertIndex)];
        }
    }

    return result;
}
